import React, { useState } from 'react';
import '../pages/Home.css'

export default function StartWindow(props) {
  const [ start, setstart ] = useState(true);
  setTimeout(function(){
    setstart(false)
  }, 1800)
  return (
    <div className={start? "startwindowdiv": "startwindowdiv startwindowclose"}>
      <div className={"startwindowinner"}>
        <h2 className={"startwindowtitle"}>SelectBook</h2>
      </div>
    </div>
  )
}